import "./Team.module.css";
import Header from "@/reusable_sections/Header";
import TeamIntroduction from "./sections/TeamIntroduction";
import CoreTeamMembers from "./sections/CoreTeamMembers";
import JoinOurNetworkCTA from "./sections/JoinOurNetworkCTA";
import Footer from "@/reusable_sections/Footer";
export default function TeamPage() {
  return <div>
      <Header />
      <TeamIntroduction />
      <CoreTeamMembers />
      <JoinOurNetworkCTA />
      <Footer />
    </div>;
}